<template>
	<div id="app" v-wechat-title="this.$route.meta.title">
		<keep-alive>
			<router-view v-if='$route.meta.keepAlive'/>
		</keep-alive>
		<router-view v-if='!$route.meta.keepAlive'/>
	</div>
</template>
<script>
    
import wx from 'weixin-js-sdk';
import { Toast,Dialog} from 'vant';
import Qs from 'qs';
export default {
    name: 'app',
	components: {
		[Toast.name]: Toast,
        [Dialog.name]:Dialog
    },
	data() {
		return {
			query:Qs.parse(location.search.substring(1)),
            currentRoute:'',
            token:'',
            // titleName:''
		}
	},
	created(){
		this.initData();
	},
    mounted(){
        // this.init();
    },
	methods: {
		initData(){
            this.istoken();
		},
        istoken(){
                var _this = this;
            // if(localStorage.getItem('token')){
            //     var _this = this;
            //     let object = {
            //         url: 'd=wxapi&c=mp_auth&m=login',
            //         data: {
            //             token:localStorage.getItem('token')
            //         },
            //         target: 'wuliu',
                    
            //         success: res => {
            //             var result = res.data;
            //             localStorage.setItem('token',result.tokencode)
            //             localStorage.setItem('session',res.session_id)
                        
            //         },
            //         complete: res => {
            //             this.getConfig();
            //         }
            //     }
            //     this.$getData(object);
            // }
            let object = {
                url: 'd=wxapi&c=mp_auth&m=login',
                data: {
                    
                    "mobile":'17700007421',
                    "password":'123456',
                    // "mobile":'17700004004',
                    // "password":'tgj3199',
                },
                target: 'wuliu',
                ismessage:true,
                success: res => {
                    var result = res.data;
                    // localStorage.setItem('token',result.tokencode)
                    // localStorage.setItem('session',res.session_id)
                },
                login:res=>{
                    // localStorage.setItem('token','')
                    // localStorage.setItem('session','')
                },
                complete: res => {
                    _this.getConfig();
                }
            }
            this.$getData(object);
        },
        getConfig(){
            var _this=this;
            let obj={
                url:'d=wxapi&c=open_config&m=get_config',
                data:{},
                target:'wuliu',
                success:res=>{
                    var result=res.data;
                    _this.$store.dispatch('set_configdata', result);
                },
            }
            this.$getData(obj);
        }
    },
    watch: {
        '$route' () {
			let obj = this.$router.currentRoute.meta;
            // this.currentRoute=this.$router.currentRoute;
            // this.token=this.$router.currentRoute.query.token;
            // if(this.$store.state.shopdata){
            //     this.getshare();
            // }
            // if(localStorage.getItem('token')){
            //     this.$cookie.set('ci_session', localStorage.getItem('token'));
            // }
            
		}
	},
}
</script>